module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "summary-heading"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "claimInfoForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "name": "claim_status",
      "label": "Status:"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.active),
      expression: "active"
    }],
    attrs: {
      "name": "claimStatus",
      "id": "claim_status",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.active = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Closed")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "open_date",
      "label": "Open Date:"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:open_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "open_date",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.openDate),
      callback: function($$v) {
        _vm.openDate = $$v
      },
      expression: "openDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('open_date')
    }
  }, [_vm._v("\n                        The Open Date is required\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [(!_vm.active) ? _c('control', {
    attrs: {
      "for": "closed_date",
      "label": "Closed Date:"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:closed_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "closed_date",
      modifiers: {
        "required": true
      }
    }],
    model: {
      value: (_vm.closeDate),
      callback: function($$v) {
        _vm.closeDate = $$v
      },
      expression: "closeDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('closed_date')
    }
  }, [_vm._v("\n                        The Closed Date is required\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.closedDateRules
    }
  }, [_vm._v("\n                        The Closed Date must be after the Open Date\n                    ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.active) ? _c('control', {
    attrs: {
      "for": "claim_outcome",
      "label": "Outcome:"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.outcome),
      expression: "outcome"
    }],
    attrs: {
      "name": "claimOutcome",
      "id": "claim_outcome",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.outcome = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Paid"
    }
  }, [_vm._v("Paid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Defended"
    }
  }, [_vm._v("Defended")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claim_outcome')
    }
  }, [_vm._v("\n                        The Outcome is required\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "flex-grid__g-2 flex-grid--input-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-7"
  }, [_c('button', {
    staticClass: "a-button a-button--no-margin",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.showBack) ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    on: {
      "click": function($event) {
        return _vm.close('showAllSummary')
      }
    }
  }, [_vm._v("Back")]) : _vm._e()])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-172545e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims-dashboard/components/ClaimInfo.vue
// module id = 1585
// module chunks = 0